import type { RateAnswerModalProps } from './component';
import type { FC } from 'react';
import { lazy, memo, Suspense } from 'react';

const ComponentLoad = lazy(async () => await import('./component'));

const RateAnswerModal: FC<RateAnswerModalProps> = props => (
  <Suspense fallback={null}>
    <ComponentLoad {...props} />
  </Suspense>
);

export default memo(RateAnswerModal);
